import React, { FC } from 'react';
import { Box } from '@mui/material';
import UpdateProfile from '../components/UserProfileComponents/UpdateProfile';

const UpdateProfileScreen: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100%',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <UpdateProfile />
        </Box>
      </Box>
    </Box>
  );
};

export default UpdateProfileScreen;
